var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4291_72132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1782 15.9995L25.7557 7.42203C25.9075 7.26486 25.9915 7.05436 25.9896 6.83586C25.9877 6.61736 25.9 6.40835 25.7455 6.25384C25.591 6.09934 25.382 6.0117 25.1635 6.0098C24.945 6.0079 24.7345 6.09189 24.5773 6.24369L15.9998 14.8212L7.42232 6.24369C7.26515 6.09189 7.05465 6.0079 6.83615 6.0098C6.61766 6.0117 6.40865 6.09934 6.25414 6.25384C6.09963 6.40835 6.01199 6.61736 6.01009 6.83586C6.00819 7.05436 6.09219 7.26486 6.24399 7.42203L14.8215 15.9995L6.24399 24.577C6.08776 24.7333 6 24.9452 6 25.1662C6 25.3872 6.08776 25.5991 6.24399 25.7554C6.40026 25.9116 6.61219 25.9993 6.83316 25.9993C7.05413 25.9993 7.26605 25.9116 7.42232 25.7554L15.9998 17.1779L24.5773 25.7554C24.7336 25.9116 24.9455 25.9993 25.1665 25.9993C25.3875 25.9993 25.5994 25.9116 25.7557 25.7554C25.9119 25.5991 25.9996 25.3872 25.9996 25.1662C25.9996 24.9452 25.9119 24.7333 25.7557 24.577L17.1782 15.9995Z",
    fill: "#9B7CC8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4291_72132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-Icon.ed535da11a07843c18bf9f61c17b6817.svg";
export { ForwardRef as ReactComponent };